import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const QuoteIconSvg = ()=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "72",
        height: "54",
        viewBox: "0 0 72 54",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M31.2772 12.4952C25.6689 13.7911 20.7222 17.0739 17.3492 21.7324C25.415 22.4794 31.7299 29.2644 31.7299 37.5252C31.7299 46.2857 24.6281 53.3875 15.8677 53.3875C7.10731 53.3874 0.00546618 46.2856 0.00546618 37.5252C0.00546681 37.3121 0.0110155 37.1 0.0193442 36.8889C-0.240269 28.9029 2.11854 21.0217 6.7776 14.4686C11.97 7.16545 19.659 2.01829 28.3898 0.000780641L31.2772 12.4952Z",
                fill: "var(--quote-icon-color, #E6E7EA)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M70.6028 12.4944C64.9944 13.7904 60.0478 17.0733 56.6748 21.7319C64.7408 22.4788 71.0559 29.2638 71.0559 37.5248C71.0559 46.2852 63.9541 53.387 55.1937 53.387C46.4333 53.387 39.3318 46.2852 39.3318 37.5248C39.3318 37.3116 39.337 37.0993 39.3453 36.8881C39.0857 28.9021 41.4445 21.0209 46.1036 14.4678C51.296 7.16463 58.9849 2.01749 67.7158 0L70.6028 12.4944Z",
                fill: "var(--quote-icon-color, #E6E7EA)"
            })
        ]
    });
export default QuoteIconSvg;
